<template>
    <AdminLocationList v-if="$store.state.auth.loggedIn && ($store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || $store.state.auth.user.role === 'limited_editor')" />
    <LocationList v-else />
</template>

<script>
import AdminLocationList from './admin/List.vue';
import LocationList from './partner/List.vue';

export default {
  components: {
    AdminLocationList,
    LocationList,
  },
};
</script>

<style>

</style>
